export default {
  meta: {
    title: '文章详情'
  }
};
